import {createReducer} from 'typesafe-actions';
import {
  SetEditorJobAction,
  SetEditorJobState,
} from 'modules/setEditorJob/types';
import {setEditJobAction} from 'modules/setEditorJob/actions';
import {
  asyncState,
  createAsyncReducer,
  transformToArray,
} from 'lib/reducerUtils';

const initialState: SetEditorJobState = {
  savePost: asyncState.initial(),
};

const setEditorJob = createReducer<SetEditorJobState, SetEditorJobAction>(
  initialState,
).handleAction(
  transformToArray(setEditJobAction),
  createAsyncReducer(setEditJobAction, 'savePost'),
);

export default setEditorJob;
